/**
 * 滚动特效已被移除，但确保所有元素默认可见
 */
export const initScrollEffects = () => {
  // 立即为所有带有滚动特效类的元素添加visible类，确保它们可见
  const elements = document.querySelectorAll('.scroll-fade-up, .scroll-fade-in, .scroll-zoom, .scroll-slide-left, .scroll-slide-right, .scroll-effect');
  elements.forEach(element => {
    element.classList.add('visible');
    
    // 移除可能导致元素不可见的类
    element.classList.remove('scroll-fade-up', 'scroll-fade-in', 'scroll-zoom', 'scroll-slide-left', 'scroll-slide-right', 'scroll-effect');
    
    // 确保元素可见
    element.style.opacity = '1';
    element.style.transform = 'none';
    element.style.visibility = 'visible';
    element.style.display = 'block';
  });
  
  // 添加全局样式以覆盖任何可能隐藏元素的CSS
  const style = document.createElement('style');
  style.textContent = `
    .scroll-fade-up, .scroll-fade-in, .scroll-zoom, .scroll-slide-left, .scroll-slide-right, .scroll-effect {
      opacity: 1 !important;
      transform: none !important;
      visibility: visible !important;
      display: block !important;
    }
  `;
  document.head.appendChild(style);
  
  // 返回空对象，保持API兼容性
  return {
    cleanup: () => {},
    showAllElements: () => {}
  };
};

/**
 * 级联延迟功能已被移除
 */
export const addCascadingDelays = (containerSelector, itemSelector, initialDelay, incrementDelay) => {
  // 空函数
  return;
};